import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import SearchCourses from 'containers/Forms/Courses/SearchCourses';
import CreateCourses from 'teams/containers/Courses/Create';
import SingleCourse from 'containers/SinglePages/SingleCourse';
import Modal from 'containers/Modals/Modal';
import { getCourses } from 'actions/courses';
import { getRootUrl } from 'helpers/url';
import React, { Component } from 'react';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ColorLabel, ColorLabelContainer, DataList } from 'UI';
import RowItem, { RowCell } from 'UI/Elements/List/RowItem';
import { Button, Icon } from '@haldor/ui';
import User from '_class/User';
import './CourseSelect.scss';

var CourseSelectList = /*#__PURE__*/function (_Component) {
  _inherits(CourseSelectList, _Component);

  var _super = _createSuper(CourseSelectList);

  function CourseSelectList(props) {
    var _this;

    _classCallCheck(this, CourseSelectList);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onToggleSearch", function (e) {
      e.preventDefault();

      _this.setState({
        searchCourses: !_this.state.searchCourses
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onToggleCreateCourse", function (e) {
      e.preventDefault();

      _this.setState({
        createCourse: !_this.state.createCourse
      });
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var courses;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.props.section != null && _this.props.section.courses != null && _this.props.section.courses.length > 0) {
                courses = [];

                _this.props.section.courses.forEach(function (course) {
                  if (_this.props.section.courseID != course.id) {
                    var schoolType = _this.props.translate(course.typeOfSchooling);

                    courses.push({
                      id: course.id,
                      title: "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(schoolType, ")"),
                      colorCode: course.colorCode,
                      status: course.status,
                      type: course.type
                    });
                  }
                });

                _this.setState({
                  courses: courses
                });
              }

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onAddCourses", function () {
      var newCourses = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var courses = _this.state.courses;
      newCourses.forEach(function (course) {
        var schoolType = _this.props.translate(course.typeOfSchooling);

        courses.push({
          id: course.id,
          title: "".concat(course.title, " ").concat(course.year != null ? course.year : '', " (").concat(schoolType, ")"),
          colorCode: course.colorCode,
          type: course.type
        });
      });

      _this.setState({
        courses: courses,
        searchCourses: false
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCreateClose", function () {
      _this.setState({
        createCourse: false
      }, function () {
        _this.onChange();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveCourse", function (course) {
      var courses = _this.state.courses;
      var courseIndex = courses.findIndex(function (co) {
        return co.id == course.id;
      });

      if (courseIndex > -1) {
        courses.splice(courseIndex, 1);

        _this.setState({
          courses: courses
        }, function () {
          _this.onChange();
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function () {
      if (_this.props.onChange) {
        _this.props.onChange(_this.state.courses);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderShowCourse", function (course) {
      _this.setState({
        showCourse: true,
        courseId: course.id
      });

      return;
    });

    _defineProperty(_assertThisInitialized(_this), "renderCourse", function (course) {
      return /*#__PURE__*/React.createElement(RowItem, {
        key: 'selected-' + course.id,
        onClick: function onClick() {
          _this.renderShowCourse(course);
        }
      }, /*#__PURE__*/React.createElement(RowCell, null, /*#__PURE__*/React.createElement(ColorLabelContainer, null, /*#__PURE__*/React.createElement(ColorLabel, {
        content: course.title,
        color: course.colorCode
      }))), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true
      }, course.status == 'COURSE_DRAFT' ? /*#__PURE__*/React.createElement("span", {
        className: "draft-badge"
      }, _this.props.translate('Draft')) : null), /*#__PURE__*/React.createElement(RowCell, {
        shrink: true
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: function onClick(e) {
          e.preventDefault();

          _this.onRemoveCourse(course);
        }
      }, _this.props.translate('Remove'))));
    });

    _this.state = {
      courses: [],
      searchCourses: false,
      createCourse: false,
      courseId: 0
    };
    return _this;
  }

  _createClass(CourseSelectList, [{
    key: "isIframe",
    value: function isIframe() {
      try {
        return window.self !== window.top;
      } catch (e) {
        return true;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var user = new User(this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "course-select"
      }, /*#__PURE__*/React.createElement(Modal, {
        onClose: function onClose() {
          return _this2.setState({
            searchCourses: false
          });
        },
        isOpen: this.state.searchCourses,
        title: this.props.translate('Add curriculum'),
        type: "small"
      }, /*#__PURE__*/React.createElement(SearchCourses, {
        onSubmit: this.onAddCourses
      })), /*#__PURE__*/React.createElement(Modal, {
        onClose: function onClose() {
          return _this2.setState({
            createCourse: false
          });
        },
        isOpen: this.state.createCourse,
        title: this.props.translate('create-course'),
        type: "small"
      }, /*#__PURE__*/React.createElement(CreateCourses, {
        onClose: this.onCreateClose
      })), /*#__PURE__*/React.createElement(Modal, {
        onClose: function onClose() {
          return _this2.setState({
            showCourse: false
          });
        },
        isOpen: this.state.showCourse,
        title: this.props.translate('update-course'),
        type: "small"
      }, /*#__PURE__*/React.createElement(SingleCourse, {
        courseId: this.state.courseId,
        onClose: this.onShowCourseClose
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), this.state.courses != null && this.state.courses.length > 0 ? /*#__PURE__*/React.createElement(DataList, {
        title: this.props.translate('Curriculums'),
        data: this.state.courses,
        renderRow: this.renderCourse
      }) : null, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '1.25rem'
        }
      }), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.onToggleSearch
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('Add curriculum')), user.isCourseAdministrator() ? /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        style: {
          marginLeft: '0.5rem'
        },
        onClick: this.onToggleCreateCourse
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", this.props.translate('create-course')) : null);
    }
  }]);

  return CourseSelectList;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    customCourses: state.Courses.courses,
    tenant: state.user.tenant
  };
}

export default connect(mapStateToProps, {
  getCourses: getCourses
})(CourseSelectList);